import { render, staticRenderFns } from "./VFileInput.vue?vue&type=template&id=3a5ecc49&scoped=true"
import script from "./VFileInput.vue?vue&type=script&lang=js"
export * from "./VFileInput.vue?vue&type=script&lang=js"
import style0 from "./VFileInput.vue?vue&type=style&index=0&id=3a5ecc49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5ecc49",
  null
  
)

export default component.exports